import { render, staticRenderFns } from "./CustomerExamine.vue?vue&type=template&id=14095148&scoped=true"
import script from "./CustomerExamine.vue?vue&type=script&lang=js"
export * from "./CustomerExamine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14095148",
  null
  
)

export default component.exports